<template>
  <v-app :class="fondo">

    <v-toolbar 
      fixed 
      app 
      :clipped-left="clipped" 
      style="background: transparent !important">
     
      <v-toolbar-title>                 
        <img style="width: 145px;" src="./assets/img/logo.gif" alt="AUNNAIT">       
      </v-toolbar-title>

      <!-- // ? Opciones de la derecha -->
      <v-spacer></v-spacer>    

      <v-btn icon color="transparent" @click="drawer = !drawer"> <v-icon color="white">menu_open</v-icon> </v-btn>      

      <v-menu
        bottom
        origin="center center"
        transition="scale-transition"
      >
        <v-btn slot="activator" round depressed>
        <img style="width: 20px; margin-right: 5px;" src="./assets/img/paleta.jpeg" alt="Informació de los colores">        
        <span style="margin-right: 5px;text-transform: none;">Info </span></v-btn>      
        <v-list>

          <v-subheader>
          MONITORIZACIÓN DE LAS COLAS
          </v-subheader>

          <v-list-tile>
            <v-list-tile-title>
              <v-btn
                style="background: linear-gradient(45deg,#239FE9,#44D5F3); width: 200px"
                round                
                small
                dark>
                Extensión libre
              </v-btn>
            </v-list-tile-title>           
          </v-list-tile>

          <v-list-tile>
            <v-list-tile-title>
              <v-btn
                style="background: linear-gradient(45deg,#FD5A49,#FDDC98); width: 200px"
                round                
                small
                dark>
                Extensión en llamada
              </v-btn>
            </v-list-tile-title>           
          </v-list-tile>

          <v-list-tile>
            <v-list-tile-title>
              <v-btn
                style="background: #ccc; width: 200px"
                round                
                small
                dark>
                Extensión pausada
              </v-btn>
            </v-list-tile-title>           
          </v-list-tile>

          <v-list-tile>
            <v-list-tile-title>
              <v-btn
                style="background: linear-gradient(45deg,#476892,#211c22); width: 200px"
                round                
                small
                dark>
                Extensión no registrada
              </v-btn>
            </v-list-tile-title>           
          </v-list-tile>

        </v-list>
      </v-menu> 

      <v-menu bottom left style="z-index: 500;">
        <v-btn icon slot="activator" dark>
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile>
            <v-list-tile-title @click="logOut" style="cursor: pointer">
              <i class="material-icons" style="float: left;margin-right: 5px;">exit_to_app</i> Cerrar sesión
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

    </v-toolbar>
     
    <v-content>
      <v-container fluid>
        <v-slide-y-transition mode="out-in">
          <router-view></router-view>
        </v-slide-y-transition>
      </v-container>
    </v-content>

    <!-- // ? LOGIN -->
    <template>
      <v-layout row justify-center>
        <v-dialog v-model="login" 
          fullscreen 
          transition="dialog-bottom-transition" 
          :overlay="false">      

          <img 
            class="fadeIn"
            style="position: absolute; margin-top: 20%; margin-left: 37%; z-index: 1000; width: 500px; " 
            src="./assets/img/aunna_logo.png" alt="AUNNAIT">

          <canvas class="fondo"></canvas>

          <v-card style="z-index: 500; background: transparent">

              <v-flex d-flex 
                style="position: absolute;
                width: 480px;
                margin-top: 23%; margin-left: 37.5%;">
                
                <v-card dark class="widget-title-login fadeIn" 
                  style="margin-top: 25%; border-radius: 10px; width: 400px; height: 300px; padding: 30px; padding-top: 10px">
                  
                  <v-card-text style="">                                      

                  <v-form 
                    v-model="valid" ref="form" 
                    lazy-validation>

                    <v-text-field
                      name="email"
                      label="Email"
                      v-model="email"
                      required
                      style="color: white"
                    ></v-text-field>

                    <v-text-field
                      type="password"
                      name="password"
                      label="Password"
                      v-model="password"
                      @keyup.enter.native="autenticate"
                      required
                    ></v-text-field>

                    <v-btn
                      style="width: 100%; background: white; color: grey; margin-left: 0px; margin-top: 30px"
                      @click="autenticate"
                      :disabled="!valid">
                      Login
                    </v-btn>

                  </v-form>

                  </v-card-text>
                </v-card>

              </v-flex>  

          </v-card>          

          <v-snackbar
            :timeout="timeout"
            color="error"      
            v-model="toInvalid">
            {{errorText}}
            <v-btn dark flat @click.native="toInvalid = false">Cerrar</v-btn>
          </v-snackbar>

        </v-dialog>  
      </v-layout>
    </template>

    <v-snackbar
      v-model="snackbar"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :color="color"
      :top="y === 'top'"
      :vertical="mode === 'vertical'">
        <v-btn dark flat> {{cliente}} </v-btn>       
        <span style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;" v-if="!isMedia && !mimetype">"{{ message }}"</span>
        <img v-else-if="isMedia && mimetype.indexOf('image') !== -1" :src="'data:image/png;base64,'+message" width="60px" height="60px" alt="">
        <img v-else-if="!isMedia && mimetype.indexOf('pdf') !== -1" :src="'data:image/png;base64,'+message" width="60px" height="60px" alt="">
        <v-btn dark flat @click="snackbar = false" > <i class="material-icons"> clear_all </i> </v-btn>        
    </v-snackbar>      

    <!-- // ? Eventos socket.io -->
    <v-navigation-drawer absolute v-model="drawer" style="background: #e0e0e0">
      <v-toolbar style="border-radius: 3px; background: linear-gradient(45deg,#239FE9,#44D5F3)" dark>
        <v-toolbar-title>Eventos Socket.io</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-toolbar dark style="background: transparent">
        <v-btn icon @click="filterIdLlamada = null"> <v-icon style="font-size: 15px; color: #333552">close</v-icon> </v-btn>   
        <v-text-field v-model="filterIdLlamada" color="#333552"></v-text-field> 
        <v-btn icon>
          <v-icon style="color: #333552">filter_list</v-icon>
        </v-btn>         
      </v-toolbar>    

       <v-divider></v-divider>  

      <v-list>                 
        <template v-for="(item, index) in getEventsSocket">
          <v-subheader :key="index" style="margin-top: 15px !important; height: 18px; justify-content: center; font-size: 14px; color: #333552">
          {{item.evento}}
          </v-subheader> 
          <v-list-tile  :key="`title${index}`" style="height: auto !important">                          
            <v-list-tile-content>
              <v-list-tile-title> <pre>{{item}}</pre></v-list-tile-title>
            </v-list-tile-content>            
          </v-list-tile>
          <v-divider :key="`divider${index}`" ></v-divider> 
        </template>
      </v-list>
            
    </v-navigation-drawer>

  </v-app>
</template>

<script>

import axios from 'axios'
import sha256 from 'sha256'

export default {
  name: 'App',
  data () {
    return {  
      login: null,     
      admin: null,            
      username: '',  
      userImg: '',  
      userID: null,  
      email: null,
      password: null,
      clipped: false,
      drawer: true,
      fixed: false,
      right: true,
      rightDrawer: false,      
      fondo: "desktop_clinica",
      menu: false,
      valid: false,  
      toInvalid: false,
      errorText: '',
      snackbar: false,
      isMedia: false,
      mimetype: null,
      message: '',      
      cliente: '',
      y: 'top',
      x: 'right',
      mode: 'multi-line',
      color: 'info',
      timeout: 5000,
      llamadas_activas: -1,
      drawer: false,
      events: [],
      filterIdLlamada: null
    }
  },
  
  mounted (){

    this.controlLogin()

    this.loadNameApp()  

  },  

  created: function (){

    this.$options.sockets.evento = (data) => {
      if (data.evento !== "queueShow" && data.evento !== "calipsoStatus") this.events.unshift(data)
      if (data.evento === 'llamadasActivas') this.llamadas_activas = data.llamadas
    }

  },     

  watch: {
    '$route': 'controlLogin'
  },

  computed:{
    getEventsSocket(){
      if (!this.filterIdLlamada) return this.events
      else return this.events.filter((e) => e.id === this.filterIdLlamada || e.idLlamada === this.filterIdLlamada)
    }
  },

  methods: {

    controlLogin(){
      
      let token = this.$localStorage.get('elecnorToken')
      //Si existe el token entonces estoy autenticado
      if ((token) && (token !== null) && (token !== 'undefined')){
        this.login = false
        this.$store.commit('loginOK')       
        if ((this.$route.path === '/Login') || (this.$route.path === '/')) this.$router.push('Dashboard')       
        this.username = this.$localStorage.get('elecnorUser')    
        this.userImg = this.$localStorage.get('elecnorImg')  
        let admin = this.$localStorage.get('elecnorAdmin')  
        if ((admin) && (admin === 'true')){
          this.admin = true
          this.$store.commit('isAdmin') 
        }else {
          this.admin = false
        }
      }else {      
        this.login = this.$store.state.login  
        this.username = this.$localStorage.get('elecnorUser')    
        this.userImg = this.$localStorage.get('elecnorImg')   
      } 
    },

    changeFondo(fondo) {
      this.$store.state.fondoTitle = 'widget-title fadeIn'
      switch (fondo) {
        case 'desktop_clinica':
          this.$store.state.fondoDialog = 'fondoDialogClinica'
          this.$store.state.fondoTitle = 'widget-title-clinica fadeIn'
          break; 
        case 'desktop_gris':
          this.$store.state.fondoDialog = 'fondoDialogGris'
          break;        
        case 'desktop_verde':
          this.$store.state.fondoDialog = 'fondoDialogVerde'
          break;
        case 'desktop_azul':
          this.$store.state.fondoDialog = 'fondoDialogAzul'
          break;   
        case 'desktop_rojo':
          this.$store.state.fondoDialog = 'fondoDialogRojo'
          break;  
        case 'desktop_negro':
          this.$store.state.fondoDialog = 'fondoDialogNegro'
          break;  
        case 'desktop_lila':
          this.$store.state.fondoDialog = 'fondoDialogLila'
          break;  
        case 'desktop_negro_gris':
          this.$store.state.fondoDialog = 'fondoDialogNegroGris'
          break;  
        case 'desktop_naranja':
          this.$store.state.fondoDialog = 'fondoDialogNaranja'
          break;  
        case 'desktop_vino':
          this.$store.state.fondoDialog = 'fondoDialogVino'
          break;                                                                
        default:
          this.$store.state.fondoDialog = 'fondoDialogAzul'
          break;
      }
      this.fondo = fondo;
    },

    autenticate(){   
      let self = this
      axios.post(`${self.$store.state.URL_API_CALIPSO}/authenticate`, {
          email: self.email,
          password: sha256(self.password)
        })
        .then(function (response) {
          axios.defaults.headers.common = {'Authorization': `bearer ${response.data.token}`}
          self.$localStorage.set('elecnorToken', response.data.token)
          self.$localStorage.set('elecnorUser', 'Elecnor')
          self.$localStorage.set('elecnorImg', 'https://pbs.twimg.com/profile_images/824964972711129088/ZZ8owGYZ.jpg')
          self.$localStorage.set('elecnorAdmin', true)
          self.$store.commit('loginOK')   
          self.login = !self.login  
          self.admin = true
          self.$store.commit('isAdmin') 
          self.$router.push('Dashboard')  
        })
        .catch(function (error) {
          console.log(error);
          self.errorText = 'Usuario o contraseña incorrectos'
          self.toInvalid = true          
        });            

    },

    logOut(){
      this.$localStorage.remove('elecnorToken')
      this.$localStorage.remove('elecnorUser')
      this.$localStorage.remove('elecnorImg')
      this.$localStorage.remove('elecnorAdmin')
      this.$store.commit('loginKO')
      this.login = !this.login  
      this.$router.push('/')
    },
    
    loadNameApp(){

      // type anything here
      const text = '';

      // this function turns a string into an array
      const createLetterArray = (string) => {
        return string.split('');
      }

      // this function creates letter layers wrapped in span tags
      const createLetterLayers = (array) => {
        return array.map((letter) => {
            let layer = '';
            //specify # of layers per letter
            for (let i = 1; i <= 2; i++) {
              // if letter is a space
              if(letter == ' '){
                layer += '<span class="space"></span>';
              }else{
                layer += '<span class="letter-'+i+'">'+letter+'</span>';
              }
            }
            return layer;
        });
      }

      // this function wraps each letter in a parent container
      const createLetterContainers = (array) => {
        return array.map((item) => {
          let container = '';
          container += '<div class="wrapper">'+item+'</div>';
          return container;
        });
      }

      // use a promise to output text layers into DOM first
      const outputLayers = new Promise(function(resolve, reject) {
            // document.getElementById('text').innerHTML = createLetterContainers(createLetterLayers(createLetterArray(text))).join('');
            // document.getElementById('text2').innerHTML = createLetterContainers(createLetterLayers(createLetterArray(text))).join('');
            resolve();
      });

      // then adjust width and height of each letter
      //const spans = Array.prototype.slice.call(document.getElementsByTagName('span'));
      const spans = Array.prototype.slice.call(document.getElementsByClassName('letter-1'));      
      outputLayers.then(() => {
          return spans.map((span) => {
            setTimeout(() => {
              span.parentElement.style.width = span.offsetWidth+'px';
              span.parentElement.style.height = span.offsetHeight+'px';
            }, 250);
          });  
      }).then(() => {
          // then slide letters into view one at a time
          let time = 250;
          return spans.map((span) => {
            time += 75;
            setTimeout(() => {
              span.parentElement.style.top = '0px';
            }, time);
          });
      });
            
    }
  }

}
</script>


<style>
  body {
    -webkit-font-smoothing: subpixel-antialiased !important;
    font-family: "Lato", "Helvetica Neue", "Segoe UI", sans-serif !important;  
    height: 100% !important;
    overflow-wrap: break-word !important;
    text-rendering: optimizeLegibility !important;
    word-wrap: break-word !important;
  }
  .theme--light .toolbar,
  .application .theme--light.toolbar {
    background-color: transparent !important;
    color: #ffffff !important;
  }
  .theme--light .footer,
  .application .theme--light.footer {
    background: transparent !important;
    color: #ffffff !important;
  }
  /* .btn .btn__content .icon {
    color: white !important;
  } */
  .toolbar {
    position: relative !important;
    -webkit-transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
    transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
    width: 100% !important;
    will-change: inherit;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
  }
  .fondo-transparente {
    background: transparent !important;
  }

  .theme--dark .stepper .stepper__step__step .icon, .application .theme--dark.stepper .stepper__step__step .icon {
      /* color: #8fbe00; */
      font-weight: bold;
  }

  .v-snack--multi-line .v-snack__content {
      height: 80px;
      padding: 24px;
      padding-left: 0px !important;
  }

  .v-list--two-line .v-list__tile {
      height: auto !important;
  }  

  .v-list__tile {
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: flex-start !important;
      color: inherit;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      font-size: 16px;
      font-weight: 400;
      height: 48px;
      margin: 0;
      padding: 0 16px;
      position: relative;
      text-decoration: none;
      -webkit-transition: .3s cubic-bezier(.25,.8,.5,1);
      transition: .3s cubic-bezier(.25,.8,.5,1);
  }   

  .v-list__tile__title {
      height: auto !important;
      line-height: 24px;
      position: relative;
      text-align: left;
  }  

  .v-toolbar {
      -webkit-transition: none;
      transition: none;
      -webkit-box-shadow: none !important;
      box-shadow: none !important;
      position: relative;
      width: 100%;
      will-change: padding-left,padding-right;
  }

  .v-content {
      -webkit-transition: none;
      transition: none;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-flex: 1;
      -ms-flex: 1 0 auto;
      flex: 1 0 auto;
      max-width: 100%;
      /* padding: 0px !important; */
      padding: 64px 0px 0px !important;  
  }  


  /* FONDOS DE LA APLICACIÓN */
  .desktop_dev {
    background: #b4b1b1 !important;
    background-attachment: fixed !important;
    background-size: cover !important;
    min-width: 960px !important;
  }

  /* rgba(0,0,0,0.38) !important */
  .desktop_clinica {    
    /* background-image: url('./assets/img/home.png') !important; */
    /* background-image: url('./assets/img/Proyectos.jpg') !important; */
    background-image: url('./assets/img/fondo2.jpg') !important;
    background-attachment: fixed !important;
    background-size: cover !important;
    min-width: 960px !important;
  }
  .fondoDialogClinica{
      background: linear-gradient(#424242, rgb(2, 14, 12) 85%) !important;
      /* background: linear-gradient(rgba(0,0,0,0.38), rgb(2, 14, 12) 85%) !important; */
      background-attachment: fixed !important;
      background-size: cover !important;
  }
  .desktop_gris {
    background-image: url('./assets/fondo-gris.jpg') !important;
    background-attachment: fixed !important;
    background-size: cover !important;
    min-width: 960px !important;
  }
  .fondoDialogGris{
      background: linear-gradient(rgb(15, 138, 115), rgb(2, 14, 12) 85%) !important;
      background-attachment: fixed !important;
      background-size: cover !important;
  }
  .desktop_verde {
    background: linear-gradient(rgb(15, 138, 115), rgb(2, 14, 12) 85%) !important;
    background-attachment: fixed !important;
    background-size: cover !important;
    min-width: 960px !important;
  }
  .fondoDialogVerde{
      background: linear-gradient(rgb(15, 138, 115), rgb(2, 14, 12) 85%) !important;
      background-attachment: fixed !important;
      background-size: cover !important;
  }
  .desktop_rojo {
    background: linear-gradient(rgb(130, 23, 29), rgb(13, 2, 3) 85%) !important;
    background-attachment: fixed !important;
    background-size: cover !important;
    min-width: 960px !important;
  }
  .fondoDialogRojo{
      background: linear-gradient(rgb(130, 23, 29), rgb(13, 2, 3) 85%) !important;
      background-attachment: fixed !important;
      background-size: cover !important;
  }
  .desktop_azul {
    background: linear-gradient(rgb(48, 67, 105), rgb(5, 7, 11) 85%) !important;    
    background-attachment: fixed !important;
    background-size: cover !important;
    min-width: 960px !important;
  }
  .fondoDialogAzul{
      background: linear-gradient(rgb(48, 67, 105), rgb(5, 7, 11) 85%) !important;
      background-attachment: fixed !important;
      background-size: cover !important;
  }


  .desktop_negro {
    background: linear-gradient(rgb(46, 42, 57), rgb(7, 6, 9) 85%) !important;    
    background-attachment: fixed !important;
    background-size: cover !important;
    min-width: 960px !important;
  }
  .fondoDialogNegro{
      background: linear-gradient(rgb(46, 42, 57), rgb(7, 6, 9) 85%) !important;
      background-attachment: fixed !important;
      background-size: cover !important;
  }

  .desktop_lila {
    background: linear-gradient(rgb(30, 50, 100), rgb(4, 6, 12) 85%) !important;    
    background-attachment: fixed !important;
    background-size: cover !important;
    min-width: 960px !important;
  }
  .fondoDialogLila{
      background: linear-gradient(rgb(30, 50, 100), rgb(4, 6, 12) 85%) !important;
      background-attachment: fixed !important;
      background-size: cover !important;
  }  
  .desktop_negro_gris {
    background: linear-gradient(rgb(38, 38, 38), rgb(8, 8, 8) 85%) !important;    
    background-attachment: fixed !important;
    background-size: cover !important;
    min-width: 960px !important;
  }
  .fondoDialogNegroGris{
      background: linear-gradient(rgb(38, 38, 38), rgb(8, 8, 8) 85%) !important;
      background-attachment: fixed !important;
      background-size: cover !important;
  }    
  .desktop_vino {
    background: linear-gradient(rgb(56, 33, 45), rgb(10, 6, 8) 85%) !important;    
    background-attachment: fixed !important;
    background-size: cover !important;
    min-width: 960px !important;
  }
  .fondoDialogVino{
      background: linear-gradient(rgb(56, 33, 45), rgb(10, 6, 8) 85%) !important;
      background-attachment: fixed !important;
      background-size: cover !important;
  } 
  .desktop_naranja {
    background: linear-gradient(rgb(120, 88, 33), rgb(12, 9, 3) 85%) !important;    
    background-attachment: fixed !important;
    background-size: cover !important;
    min-width: 960px !important;
  }
  .fondoDialogNaranja{
      background: linear-gradient(rgb(120, 88, 33), rgb(12, 9, 3) 85%) !important;
      background-attachment: fixed !important;
      background-size: cover !important;
  }   

  .widget-title-login {
    background-attachment: fixed !important;
    background-size: cover !important;
    /* background-color: rgba(0,0,0,0.54) !important;     */
    /* background-color: rgba(79, 170, 219, 0.37) !important;     */
    background-color: rgba(79, 170, 219, 0.26) !important;    
    color: white !important;
    box-shadow: 0 2px 2px 1px rgba(0,0,0,.14), 2 2px 2px 1px rgba(0,0,0,.14), 2 2px 2px 1px rgba(0,0,0,.14), 2 2px 2px 1px rgba(0,0,0,.14) !important;    
  }

  .widget-title {
    background-attachment: fixed !important;
    background-size: cover !important;
    background-color: rgba(255, 255, 255, 0.2) !important;  
    color: white !important;
  }

  .widget-title-clinica {
    background-attachment: fixed !important;
    background-size: cover !important;
    /* background-color: rgba(0,0,0,0.38) !important;   */
    background-color: rgba(0,0,0,0.30) !important;  
    color: white !important;
  }

  .content {
      -webkit-box-flex: 1 !important;
      -ms-flex: 1 1 auto !important;
      flex: 1 1 auto !important;
      max-width: 100% !important;
      -webkit-transition: 0.2s padding cubic-bezier(0.4, 0, 0.2, 1) !important;
      transition: 0.2s padding cubic-bezier(0.4, 0, 0.2, 1) !important;
      will-change: padding !important;
      padding: 0px !important;
      padding-bottom: 150px !important;
  }
  .container {
      -webkit-box-flex: 1 !important;
      -ms-flex: 1 1 100% !important;
      flex: 1 1 100% !important;
      margin: auto !important;
      padding: 16px !important;
      padding-top: 0px !important;
      width: 100% !important;
  }

  .fondo {
    width: 100%;
    height: 100%;
    position: absolute !important; 
    z-index: 100 !important;
    /* background: url(./assets/img/home.png) no-repeat center center fixed !important;  */
    background: url(./assets/img/fondo2.jpg) no-repeat center center fixed !important; 
    -webkit-background-size: cover !important;
    -moz-background-size: cover !important;
    -o-background-size: cover !important;
    background-size: cover !important;
  }

  .theme--light .input-group:not(.input-group--error) label, .application .theme--light.input-group:not(.input-group--error) label {
      color: white !important;
  }

  .theme--light .textoGris:not(.input-group--error) label, .application .theme--light.textoGris:not(.input-group--error) label {
      color: rgba(0,0,0,0.54) !important;
  }

  .dialog--fullscreen {
      margin: 0;
      height: 100%;
      position: fixed;
      overflow-x: hidden !important;
      overflow-y: hidden !important;
      top: 0;
      left: 0;
  }



  .sinFondo {
      -webkit-box-shadow: none !important;
      box-shadow: none !important;
  }


  /* CSS del nombre de la App en login */
  #text {  
    width: 305px;
    text-shadow: rgba(255, 255, 255, 0.5) 0px 3px 20px;
    color: #ffffff5c;
    font-style: oblique;
    letter-spacing: 3px;
    font-family: 'Fredoka One', sans-serif;
    font-size: 20px;
    line-height: 1em;
    text-align: center;
    position: absolute;
    top: -90px;
    transform: translateY(-50%);
  }

  #text:hover {
    cursor: default;
  }

  #text2 {  
    width: 340px;
    text-shadow: rgba(255, 255, 255, 0.5) 0px 3px 20px;
    color: #ffffff5c;
    font-style: oblique;
    letter-spacing: 3px;
    font-family: 'Fredoka One', sans-serif;
    font-size: 25px;
    line-height: 1em;
    text-align: center;
    margin-top: 30px;
    margin-left: 40px;
    /* position: absolute;
    top: -90px; */
    transform: translateY(-50%);
  }

  #text2:hover {
    cursor: default;
  }  
  
  .wrapper {
    display: inline-block;
    top: -900px;
    position: relative;
    height: 150px; /* default */
    width: 20px; /* default */
    transition: ease 0.5s all;
  }

  .wrapper span {
      position: absolute;
      top:0;
      right:0;
      transition: ease 0.5s all;
  }
      
  .space {
    padding: 0;
    min-width: 30px;
    display: inline-block;
  }

  .ahashakeheartache {
    -webkit-animation: kf_shake 1s 1 linear;
    -moz-animation: kf_shake 1s 1 linear;
    -o-animation: kf_shake 1s 1 linear;
  }
  @-webkit-keyframes kf_shake {
    0% { -webkit-transform: translate(30px); }
    20% { -webkit-transform: translate(-30px); }
    40% { -webkit-transform: translate(15px); }
    60% { -webkit-transform: translate(-15px); }
    80% { -webkit-transform: translate(8px); }
    100% { -webkit-transform: translate(0px); }
  }
  @-moz-keyframes kf_shake {
    0% { -moz-transform: translate(30px); }
    20% { -moz-transform: translate(-30px); }
    40% { -moz-transform: translate(15px); }
    60% { -moz-transform: translate(-15px); }
    80% { -moz-transform: translate(8px); }
    100% { -moz-transform: translate(0px); }
  }
  @-o-keyframes kf_shake {
    0% { -o-transform: translate(30px); }
    20% { -o-transform: translate(-30px); }
    40% { -o-transform: translate(15px); }
    60% { -o-transform: translate(-15px); }
    80% { -o-transform: translate(8px); }
    100% { -o-origin-transform: translate(0px); }
  }
    
.v-list__tile {
  height: auto !important;
}    


/* SCROLL */

::-webkit-scrollbar {
    width: 10px;
    height: 5px;
    background: #F6F8F9;
}
 
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); 
    border-radius: 10px;
}
 
::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5); 
}

pre {
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue